import { render, staticRenderFns } from "./textDragDrop.vue?vue&type=template&id=28e89016&scoped=true"
import script from "./textDragDrop.vue?vue&type=script&lang=js"
export * from "./textDragDrop.vue?vue&type=script&lang=js"
import style0 from "./textDragDrop.vue?vue&type=style&index=0&id=28e89016&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e89016",
  null
  
)

export default component.exports